'use strict';

const $ = require('jquery');

$(document).ready(function() {
    var formFields = $('.widget');

    formFields.each(function() {
        var field = $(this);
        var input = field.find('input, textarea');
        var label = field.find('label');

        /**
         * Check if field has value
         */
        function checkInput() {
            var valueLength = input.val().length;

            if (valueLength > 0) {
                label.addClass('freeze');
            } else {
                label.removeClass('freeze');
            }
        }

        input.change(function() {
            checkInput();
        });
    });
    $('input, textarea').blur(function() {
        $(this).prev().removeClass('focus');
    })
        .focus(function() {
            $(this).prev().addClass('focus');
        });
});
